export default __webpack_public_path__ + "static/media/Ab1.1feba946.mp3";